import { Box } from 'braid-design-system';
import React from 'react';

import { DropdownMenu } from './Mobile/DropdownMenu';
import { Navbar } from './Mobile/Navbar';
import {
  dropdownStateDataAttr,
  mobileHeaderContainerId,
  navHeaderBannerIds,
} from './utils/generalUtils';
import type { RenderVariant } from './utils/typeUtils';

import * as styles from './MobileHeader.css';

interface MobileHeaderProps {
  variant: RenderVariant;
  baseUrl: string;
  advertiserCentreUrl: string;
}

export const MobileHeader = ({
  variant,
  baseUrl,
  advertiserCentreUrl,
}: MobileHeaderProps) => (
  <Box
    component="header"
    id={mobileHeaderContainerId}
    className={styles.mobileHeaderRoot}
    data={{
      testid: navHeaderBannerIds.mobile,
      [dropdownStateDataAttr]: 'closed',
    }}
  >
    <nav aria-label="Main menu">
      <Navbar variant={variant} baseUrl={baseUrl} />
      <DropdownMenu
        variant={variant}
        baseUrl={baseUrl}
        advertiserCentreUrl={advertiserCentreUrl}
      />
    </nav>
  </Box>
);
